var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-layout', [_vm._l(_vm.statuses, function (item, index) {
    return [_c('v-btn', {
      key: index,
      on: {
        "click": function click($event) {
          _vm.filter.status = item.value, _vm.search(true);
        }
      }
    }, [_vm._v(_vm._s(item.name))])];
  })], 2), _c('v-row', [_vm._l(_vm.applications, function (application, index) {
    return [_c('v-col', {
      key: index,
      attrs: {
        "cols": "3"
      }
    }, [_c('v-sheet', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "color": "grey lighten-2"
      },
      on: {
        "click": function click($event) {
          return _vm.$router.push("/developer/kea/applications/" + application._id);
        }
      }
    }, [application.thumb ? _c('v-img', {
      attrs: {
        "src": application.thumb.src,
        "width": "100%",
        "height": "396",
        "contain": ""
      }
    }) : _vm._e(), _c('div', [_c('b', [_vm._v("제목: " + _vm._s(application.subject))])]), application.status == '모집중' ? _c('div', [_vm._v("★★모집중★★")]) : _vm._e(), application.status == '모집 종료' ? _c('div', [_vm._v("♧♧모집 종료♧♧")]) : _vm._e(), _c('ul', [_vm._l(application.items, function (item, index) {
      return [_c('li', {
        key: index
      }, [_c('b', {
        staticClass: "d-inline",
        domProps: {
          "innerHTML": _vm._s(item.title.replace(/\n/g, '<br/>'))
        }
      }), _vm._v(" : "), _c('p', {
        staticClass: "d-inline ma-0",
        domProps: {
          "innerHTML": _vm._s(item.txt.replace(/\n/g, '<br/>'))
        }
      })])];
    })], 2), _c('ul', [_vm._l(application.helpItems, function (item, index) {
      return [_c('li', {
        key: index
      }, [_c('b', {
        staticClass: "d-inline",
        domProps: {
          "innerHTML": _vm._s(item.title.replace(/\n/g, '<br/>'))
        }
      }), _vm._v(" : "), _c('p', {
        staticClass: "d-inline ma-0",
        domProps: {
          "innerHTML": _vm._s(item.txt.replace(/\n/g, '<br/>'))
        }
      })])];
    })], 2)], 1)], 1)];
  })], 2), _c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }